import { render, staticRenderFns } from "./SpecialApproval.vue?vue&type=template&id=6a982a8e&scoped=true&"
import script from "./SpecialApproval.vue?vue&type=script&lang=js&"
export * from "./SpecialApproval.vue?vue&type=script&lang=js&"
import style0 from "./SpecialApproval.vue?vue&type=style&index=0&id=6a982a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a982a8e",
  null
  
)

export default component.exports